import React, { useEffect, useState } from "react";
import { Toast } from "react-bootstrap";
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { getCustomerById, updateCustomer } from "../../../actions/CustomerActions";
import { ThreeDots } from "react-loader-spinner";

function EditCustomerModal(props) {
    const { customerId } = props;
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if (customerId !== undefined) {
            dispatch(getCustomerById(customerId));
        }
    }, [customerId]);

    const customer = useSelector(state => state?.customer?.customer);
    const loading = useSelector(state => state?.loading?.loading);

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [phone, setPhone] = useState('');
    const [fax, setFax] = useState('');
    const [trn_number, setTrn] = useState('');
    const [address, setAddress] = useState('');

    useEffect(() => {
        if (customer && Object.keys(customer).length > 0) {
            setName(customer.name ?? '');
            setEmail(customer.email ?? '');
            setPhone(customer.phone ?? '');
            setMobile(customer.mobile ?? '');
            setTrn(customer.trn_number ?? '');
            setFax(customer.fax ?? '');
            setAddress(customer.address ?? '');
        }
    }, [customer])

    const save = () => {
        if (name.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Name is Required!'
            })
        } else if (mobile.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Mobile No. is Required!'
            })
        }
        else {
            let data = {
                name: name,
                email: email,
                phone: phone,
                mobile: mobile,
                fax: fax,
                trn_number: trn_number,
                address: address,
            }
            dispatch(updateCustomer(data, customerId, ''));
        }
        // window.location.href = ('/state');
    }
    const [isEmailValid, setIsEmailValid] = useState(true);

    const handleChangeEmail = (e) => {
        setEmail(e.target.value);

        // Validate the email format
        const isValidEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(e.target.value);
        setIsEmailValid(isValidEmail);
    };

    const [isNameValid, setIsNameValid] = useState(true);

    const handleChangeName = (e) => {
        setName(e.target.value);

        // Validate the name format (no numbers allowed)
        const isValidName = /^[a-zA-Z\s]*$/.test(e.target.value);
        setIsNameValid(isValidName);
    };

    const [isMobileValid, setIsMobileValid] = useState(true);

    const handleChangeMobile = (e) => {
        setMobile(e.target.value);

        // Validate the phone number format
        const isMobileValid = /^[0-9]*$/.test(e.target.value);
        setIsMobileValid(isMobileValid);
    };

    const [isPhoneValid, setIsPhoneValid] = useState(true);
    const handleChangePhone = (e) => {
        setPhone(e.target.value);

        // Validate the phone number format
        const isValidPhone = /^[0-9]*$/.test(e.target.value);
        setIsPhoneValid(isValidPhone);
    };

    return (
        <React.Fragment>
            {/* Edit Vehicle Modal */}
            <div id="customer-modal" className="modal fade" tabindex="-1" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        {/* <!-- BEGIN: Modal Header --> */}
                        <div className="modal-header">
                            <h2 className="fw-medium fs-base me-auto">Vehicle Details</h2>
                        </div>
                        {/* </div> <!-- END: Modal Header --> */}
                        {/* <!-- BEGIN: Modal Body --> */}
                        <div className="modal-body">
                            {
                                loading ?
                                    <ThreeDots
                                        height="80"
                                        width="80"
                                        radius="9"
                                        color="#2d3748"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                                        wrapperClassName=""
                                        visible={loading}
                                    /> :
                                    <span>
                                        <div className="intro-y p-5 pt-0">
                                            <div className="grid columns-12">
                                                <div className="intro-y g-col-12 g-col-sm-6">
                                                    <label for="name" className="form-label">Name :</label>
                                                    <input id="name" name="name" value={name} onChange={(e) => handleChangeName(e)} type="text" className={`form-control ${isNameValid ? '' : 'is-invalid'}`} placeholder="Enter Name" />
                                                    {isNameValid == false && <div className="invalid-feedback">Please enter a valid name without numbers.</div>}

                                                </div>
                                                <div className="intro-y g-col-12 g-col-sm-6">
                                                    <label for="email" className="form-label">Email :</label>
                                                    <input id="email" name="email" type="text" value={email} onChange={(e) => handleChangeEmail(e)} className={`form-control ${isEmailValid ? '' : 'is-invalid'}`} placeholder="Enter Email" />
                                                    {!isEmailValid && <div className="invalid-feedback">Please enter a valid email address.</div>}

                                                </div>
                                                <div className="intro-y g-col-12 g-col-sm-6">
                                                    <label for="mobile" className="form-label">Mobile :</label>
                                                    <input id="mobile" name="mobile" type="text" value={mobile} onChange={(e) => handleChangeMobile(e)} className={`form-control ${isMobileValid ? '' : 'is-invalid'}`} placeholder="Enter Mobile No." />
                                                    {!isMobileValid && <div className="invalid-feedback">Please enter a valid phone without alphabets.</div>}

                                                </div>
                                                <div className="intro-y g-col-12 g-col-sm-6">
                                                    <label for="phone" className="form-label">Phone :</label>
                                                    <input id="phone" name="phone" type="text" value={phone} onChange={(e) => handleChangePhone(e)} className={`form-control ${isPhoneValid ? '' : 'is-invalid'}`} placeholder="Enter Phone No." />
                                                    {!isPhoneValid && <div className="invalid-feedback">Please enter a valid phone without alphabets.</div>}
                                                </div>
                                                <div className="intro-y g-col-12 g-col-sm-6">
                                                    <label for="fax" className="form-label">FAX :</label>
                                                    <input id="fax" name="fax" type="text" value={fax} onChange={(e) => setFax(e.target.value)} className="form-control" placeholder="Enter FAX" />
                                                </div>
                                                <div className="intro-y g-col-12 g-col-sm-6">
                                                    <label for="trn" className="form-label">TRN# :</label>
                                                    <input id="trn" name="trn" type="text" value={trn_number} onChange={(e) => setTrn(e.target.value)} className="form-control" placeholder="Enter TRN#" />
                                                </div>
                                                <div className="intro-y g-col-12 g-col-sm-6">
                                                    <label for="address" className="form-label">Address :</label>
                                                    <input id="address" name="address" type="text" value={address} onChange={(e) => setAddress(e.target.value)} className="form-control" placeholder="Enter Address" />
                                                </div>
                                            </div>
                                            {/* <!-- END: Form Layout --> */}
                                        </div>
                                    </span>
                            }
                        </div>
                        {/* <!-- END: Modal Body --> */}
                        {/* <!-- BEGIN: Modal Footer --> */}
                        <div className="modal-footer text-end"> <button type="button" data-bs-dismiss="modal" className="btn btn-outline-secondary w-20 me-1">Cancel</button> <button onClick={save} type="button" disabled={loading ? true : false} className="btn btn-primary w-24 ms-2">Save</button></div>
                    </div>
                </div>
            </div>
            {/*End Edit Vehicle Modal */}
        </React.Fragment>
    )
}

export default EditCustomerModal;